import React, { useContext, useEffect, useState } from 'react';

import { PagesContext } from '../store/PagesContext';

import orangePolygon from '../assets/images/svg/orange-polygon.svg';

import Intro from 'routes/decision-trees/components/Intro';
import SpreadPopup from '../components/popups/SpreadPopup';

const NsoG = () => {
  const [, setLastPage] = useContext(PagesContext);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const openPopup = () => setIsPopupOpen(true);

  useEffect(() => setLastPage('nsoD'), []);

  return (
    <div className='mw-700 m-auto with-top-corner with-bottom-corner px-4'>
      <img src={orangePolygon} className='corner-red-top-left' alt='' />
      <img src={orangePolygon} className='corner-red-bottom-right' alt='' />

      <SpreadPopup isPopupOpen={isPopupOpen} setIsPopupOpen={setIsPopupOpen} />

      <Intro size='middle' background={orangePolygon}>
        <h2>
          You will pay
          <br />
          ordinary income
          <br />
          tax on the{' '}
          <span className='color-black c-pointer' onClick={openPopup}>
            spread
          </span>{' '}
          of
          <br />
          each exercised
          <br />
          option.
        </h2>
      </Intro>
    </div>
  );
};

export default NsoG;
